import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ICandidateData } from 'src/types/client/clients';

interface JobOption {
  jobOrderId: number;
  jobOrderTitle: string;
}

@Component({
  selector: 'app-client-candidates',
  templateUrl: './client-candidates.component.html',
  styleUrls: ['./client-candidates.component.css']
})
export class ClientCandidatesComponent implements OnInit {
  candidatesData: ICandidateData[] = [];
  @Input() clientID: string = '';
  @Input() clientCorporation: string = '';
  displayLoader: boolean = true;
  jobOptions: JobOption[] = [];
  selectedJobId: number | null = null;
  currentSortColumn: keyof ICandidateData | '' = '';
  sortDirection: boolean = true; // true for ascending, false for descending

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.fetchCandidates();
  }

  fetchCandidates() {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/ClientPlacements?clientId=${this.clientID}`;
    this.http.get(url, {}).subscribe(
        (response: any) => {
          this.candidatesData = response.data || [];
          this.createJobOptions();
          if (this.jobOptions.length > 0) {
            this.selectedJobId = this.jobOptions[0].jobOrderId;
          }
          this.displayLoader = false;
        },
        (error) => {
          console.error('Error fetching candidates:', error);
          this.displayLoader = false;
        }
      );
  }

  createJobOptions(): void {
    if (!Array.isArray(this.candidatesData)) {
      this.jobOptions = [];
      return;
    }

    const uniqueJobs = new Map<number, string>();
    this.candidatesData.forEach(candidate => {
      if (candidate && candidate.jobOrderId !== null && candidate.jobOrderId !== undefined) {
        uniqueJobs.set(candidate.jobOrderId, candidate.jobOrderTitle);
      }
    });

    this.jobOptions = Array.from(uniqueJobs.entries()).map(([jobOrderId, jobOrderTitle]) => ({ jobOrderId, jobOrderTitle }))
      .sort((a, b) => a.jobOrderTitle.localeCompare(b.jobOrderTitle));
  }

  sort(column: keyof ICandidateData) {
    if (this.currentSortColumn === column) {
      this.sortDirection = !this.sortDirection;
    } else {
      this.currentSortColumn = column;
      this.sortDirection = true;
    }
  }

  get selectedCandidates(): ICandidateData[] {
    if (this.selectedJobId === null) {
      return [];
    }
    
    const filteredCandidates = this.candidatesData.filter(c => c.jobOrderId === this.selectedJobId);

    const sortColumn = this.currentSortColumn;
    if (sortColumn) {
      return filteredCandidates.sort((a, b) => {
        let valueA = a[sortColumn];
        let valueB = b[sortColumn];

        if (valueA === null || valueA === undefined) valueA = '';
        if (valueB === null || valueB === undefined) valueB = '';

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        }

        let comparison = 0;
        if (valueA > valueB) {
          comparison = 1;
        } else if (valueA < valueB) {
          comparison = -1;
        }

        return this.sortDirection ? comparison : -comparison;
      });
    }

    return filteredCandidates;
  }
}

